import Vue from 'vue';
import Router from 'vue-router';
import JWTHelper from '@/jwt-token';
import Login from '@/views/login';
import DashboardView from '@/views/dashboard';
import ConfirmationPage from '@/views/service-log/confirmation-page';
import HistoryContainer from '@/views/service-log/history-container';
import CreateSL from '@/views/service-log/create-service-log';
import SlEdit from '@/views/service-log/edit-service-log';
import SlCopy from '@/views/service-log/copy-service-log';
import SlSearch from '@/views/service-log/service-log-search';
import Scheduler from '@/views/scheduler/scheduler-container';
import Version from '../../version';

Vue.use(Router);

// auth guard, checks if the user-token is in local storage
function isAuthenticated(to, from, next) {
  if (!JWTHelper.isExpired()) {
    next();
    return;
  }
  next('/login');
}

function hasServiceLogRights(to, from, next) {
  if (!JWTHelper.isExpired() && JWTHelper.hasServiceLogRights()) {
    next();
    return;
  }
  next('/login');
}

// auth guard to make sure user is authenticated and an scheduler
function hasSchedulerRights(to, from, next) {
  if (!JWTHelper.isExpired() && JWTHelper.hasSchedulerRights()) {
    next();
    return;
  }
  next('/login');
}

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      beforeEnter: isAuthenticated
    },
    {
      path: '/login',
      component: Login
    },
    {
      path: '/dashboard',
      component: DashboardView,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/create',
      component: CreateSL,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/confirmation/:sessionId',
      component: ConfirmationPage,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/history',
      component: HistoryContainer,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/edit/:sessionId',
      component: SlEdit,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/copy/:sessionId',
      component: SlCopy,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/search',
      component: SlSearch,
      beforeEnter: hasServiceLogRights
    },
    {
      path: '/scheduler',
      component: Scheduler,
      beforeEnter: hasSchedulerRights
    },
    {
      path: '/version',
      component: Version
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js